'use strict';

var _regeneratorRuntime = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _awaitAsyncGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CID = require('cids');

var multiaddr = require('multiaddr');

var toCamel = require('../lib/object-to-camel');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

var multipartRequest = require('../lib/multipart-request');

var abortSignal = require('../lib/abort-signal');

var _require = require('native-abort-controller'),
    AbortController = _require.AbortController;

module.exports = configure(function (api) {
  /**
   * @type {import('..').ImplementsMethod<'put', import('ipfs-core/src/components/dht')>}
   */
  function put(_x, _x2) {
    return _put.apply(this, arguments);
  }

  function _put() {
    _put = _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(key, value) {
      var options,
          controller,
          signal,
          res,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          message,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              // allow aborting requests on body errors
              controller = new AbortController();
              signal = abortSignal(controller.signal, options.signal); // @ts-ignore https://github.com/ipfs/js-ipfs-utils/issues/90

              _context.t0 = _awaitAsyncGenerator;
              _context.t1 = api;
              _context.t2 = _objectSpread;
              _context.t3 = {
                timeout: options.timeout,
                signal: signal,
                searchParams: toUrlSearchParams(_objectSpread({
                  arg: key
                }, options))
              };
              _context.next = 9;
              return _awaitAsyncGenerator(multipartRequest(value, controller, options.headers));

            case 9:
              _context.t4 = _context.sent;
              _context.t5 = (0, _context.t2)(_context.t3, _context.t4);
              _context.t6 = _context.t1.post.call(_context.t1, 'dht/put', _context.t5);
              _context.next = 14;
              return (0, _context.t0)(_context.t6);

            case 14:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 17;
              _iterator = _asyncIterator(res.ndjson());

            case 19:
              _context.next = 21;
              return _awaitAsyncGenerator(_iterator.next());

            case 21:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 25;
              return _awaitAsyncGenerator(_step.value);

            case 25:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 36;
                break;
              }

              message = _value;
              message = toCamel(message);
              message.id = new CID(message.id);

              if (message.responses) {
                message.responses = message.responses.map(function (_ref) {
                  var ID = _ref.ID,
                      Addrs = _ref.Addrs;
                  return {
                    id: ID,
                    addrs: (Addrs || []).map(function (a) {
                      return multiaddr(a);
                    })
                  };
                });
              }

              _context.next = 33;
              return message;

            case 33:
              _iteratorNormalCompletion = true;
              _context.next = 19;
              break;

            case 36:
              _context.next = 42;
              break;

            case 38:
              _context.prev = 38;
              _context.t7 = _context["catch"](17);
              _didIteratorError = true;
              _iteratorError = _context.t7;

            case 42:
              _context.prev = 42;
              _context.prev = 43;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 47;
                break;
              }

              _context.next = 47;
              return _awaitAsyncGenerator(_iterator.return());

            case 47:
              _context.prev = 47;

              if (!_didIteratorError) {
                _context.next = 50;
                break;
              }

              throw _iteratorError;

            case 50:
              return _context.finish(47);

            case 51:
              return _context.finish(42);

            case 52:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 38, 42, 52], [43,, 47, 51]]);
    }));
    return _put.apply(this, arguments);
  }

  return put;
});